import { Button, Tab, Tabs } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { PsLabel } from "../../components";
import PsModalWindow from "../../components/PsModalWindow";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import PartnerHome from "./partnerHome";
import PartnerBank from "./partnerBank";
import WhiteLabel from "./whiteLabel";
import SmsEmail from "./smsEmail";

const NewEditPartner = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const { openDialog } = useDialog();

  const [value, setValue] = useState(0); // State for tab selection

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Spin spinning={loader}>
      {/* Add the 'scrollable' prop to make tabs responsive */}
      <Tabs
        value={value}
        onChange={handleTabChange}
        aria-label="school tabs"
        variant="scrollable" // Makes the tabs scrollable on small screens
        scrollButtons="auto" // Allows the tabs to scroll automatically on overflow
        sx={{
          display: "flex",
          justifyContent: "space-between", // Ensures spacing between tabs
        }}
      >
        <Tab label="Home" />
        <Tab label="Bank" />
        <Tab label="White Label" />
        <Tab label="SMS/Email" />
      </Tabs>

      {value === 0 && (
        <PartnerHome
          dataSource={props.dataSource}
          onSuccess={props.onSuccess}
        />
      )}
      {value === 1 && (
        <PartnerBank
          dataSource={props.dataSource}
          onSuccess={props.onSuccess}
        />
      )}
      {value === 2 && <WhiteLabel dataSource={props.dataSource} />}
      {value === 3 && <SmsEmail dataSource={props.dataSource} />}
    </Spin>
  );
};

export default NewEditPartner;
